'use strict';

var Steps = require('./Steps');
Steps.Step = require('./Step');

module.exports = Steps;


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.2.0@rc-steps/lib/index.js
 ** module id = 440
 ** module chunks = 0
 **/